import React from "react";
import { IWelcomeData } from "../../exports/interfaces";
import { Fade } from "react-awesome-reveal";
import { marked } from "marked";
import useMobile from "../../hooks/useMobile";
import useTab from "../../hooks/useTab";

const Welcome = (props: { welcomeData: IWelcomeData[] }) => {
  const mobile = useMobile();
  const tab = useTab();
  return (
    <section className="welcome-one" style={{padding: '90px 0px 74px 0px'}}>
      <div className="container">
        <div className="section-title custom-text-center">
          <span className="custom-fontweight">{props?.welcomeData[0]?.attributes?.Welcome_Title}</span>
          <h2 className="section-title__title">
            {props?.welcomeData[0]?.attributes?.Title}
          </h2>
        </div>

        <div className="row">
          <div className="col-xl-12">
            <div style={{ width: "100%", position: "relative" }}>
              <div
                className="welcome-one__img-box"
                style={{
                  float: (!mobile && !tab) ? "left" : "unset",
                  width: !mobile && !tab ? "45%" : "100%",
                  marginRight: (!mobile && !tab) ? "50px" : 'unset',
                  marginBottom: "1rem",
                  // marginLeft: (!mobile && !tab) ? "75px" : 'unset',
                }}
              >
                <Fade cascade damping={0.2} direction="left" triggerOnce={true}>
                  <div className="welcome-one__img">
                    <img
                      src={props?.welcomeData[0]?.attributes?.Image?.data?.attributes?.url && `${process.env.REACT_APP_strapiUrl}${props?.welcomeData[0]?.attributes?.Image?.data?.attributes?.url}`}
                      alt="welcome-image"
                      style={{
                        objectFit: "cover",
                        width: "100%",
                        height: "498px",
                        objectPosition: "top",
                      }}
                    />
                    <div className="mt-2">
                      <h3 className="custom-image-name">{props?.welcomeData[0]?.attributes?.Name}</h3>
                      <p style={{marginBottom: 'unset'}}>{props?.welcomeData[0]?.attributes?.Position}</p>
                      <p style={{marginBottom: 'unset'}}>{props?.welcomeData[0]?.attributes?.Company_Name}</p>
                    </div>
                  </div>
                  {/* {props?.welcomeData[0]?.attributes?.Small_Image?.data && (
                    <div className="welcome-one__small-img">
                      <img
                        src={`${process.env.REACT_APP_strapiUrl}${props?.welcomeData[0]?.attributes?.Small_Image?.data?.attributes?.url}`}
                        alt="welcome-small-image"
                        style={{
                          objectFit: "cover",
                          width: "200px",
                          height: "200px",
                          marginTop: "20px",
                        }}
                      />
                    </div>
                  )} */}
                </Fade>
              </div>

              {/* Text wraps around image */}
              <div>
                  <div
                    className="welcome-one__text-2"
                    style={{
                      textAlign: "justify",
                      paddingBottom: "unset",
                    }}
                    dangerouslySetInnerHTML={{ __html: marked(props?.welcomeData[0]?.attributes?.Description || "") as string }}
                  />
              </div>

              {/* Clear floated image */}
              {/* <div style={{ clear: "both" }}></div> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Welcome;
